import { Box, Stack, Typography } from '@mui/material';
import { variants } from '../../../variants/variants';
import SelectAnswer from '../components/common/SelectAnswer';

export const createMessage = (content, options = {}) => {
  const {
    select = false,
    type = 'incoming',
    designation,
    title,
    question,
    startButton = false,
    fullWidth = false,
    totalQuestions,
  } = options;
  const message = {
    type: type,
    model: {
      direction: type,
      position: 'single',
    },
    content:
      type === 'incoming' ? (
        <Box>
          <Typography component='div' sx={{ fontSize: variants.BODY }}>
            {content}
          </Typography>
          {select && (
            <Stack direction='row' alignItems={'flex-end'}>
              <SelectAnswer designation={designation} title={title} question={question} />
              <Typography sx={{ fontSize: variants.TINY, fontWeight: 600, ml: 'auto' }}>
                {Number(1 + question) + '/' + totalQuestions}{' '}
              </Typography>
            </Stack>
          )}
        </Box>
      ) : (
        <Typography component='div' sx={{ fontSize: variants.BODY }}>
          {content}
        </Typography>
      ),
    avatar: type === 'incoming' ? true : false,
    startButton,
    fullWidth,
  };

  return message;
};
